import { RestClientService } from '@app/app/shared/services/rest-client.service';
import { environment } from '@app/environments/environment';
import { ApiRegistrationsDataService } from './api-registrations-data.service';
import { MockRegistrationsDataService } from './mock-registrations-data.service';
import { RegistrationsDataService } from './registrations-data.service';

export function registrationsServiceFactory(client: RestClientService): RegistrationsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockRegistrationsDataService();
  }
  return new ApiRegistrationsDataService(client);
}
